import { render } from "./ChangeDelivery.vue?vue&type=template&id=129a8748"
import script from "./ChangeDelivery.vue?vue&type=script&lang=js"
export * from "./ChangeDelivery.vue?vue&type=script&lang=js"

import "./ChangeDelivery.vue?vue&type=style&index=0&id=129a8748&lang=css"
script.render = render

export default script